import React from 'react';
import { SdgProject } from '../../types';
import SdgHeader from './SdgHeader';
import SdgMain from './SdgMain';

type SdgContainerProps = {
  allProjectsLink?: string;
  buttonPrevLabel?: string;
  buttonNextLabel?: string;
  background?: string;
  displayType: string;
  headline?: string;
  introText?: string;
  mainFocusText?: string;
  sdgProjects: SdgProject[];
};

const SdgContainer = ({
  allProjectsLink,
  buttonPrevLabel,
  buttonNextLabel,
  background,
  displayType,
  headline,
  introText,
  mainFocusText,
  sdgProjects,
}: SdgContainerProps): JSX.Element => {
  return (
    <div>
      <div className={`${background === 'blue' ? 'blue-background' : 'gray-background'} sdg-connect`}>
        <SdgHeader {...{ headline, introText }} />
        <SdgMain {...{ displayType, sdgProjects, mainFocusText, allProjectsLink, buttonPrevLabel, buttonNextLabel }} />
      </div>
    </div>
  );
};

export default SdgContainer;
